import {Component, OnInit, ChangeDetectorRef, OnDestroy} from '@angular/core';
import {MdDialog, MdDialogRef} from '@angular/material';
import {PaymentDetailDialogComponent} from './payment-detail-dialog/payment-detail-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import {PaymentsService, ScrollService, ScrollParams} from '../../api';
import * as _ from 'lodash';
import 'intl';
import 'intl/locale-data/jsonp/en';
@Component({
    selector: 'app-payment-history',
    templateUrl: './payment-history.component.html',
    styleUrls: ['./payment-history.component.css']
})
export class PaymentHistoryComponent implements OnInit, OnDestroy {
    dialogRef: MdDialogRef<PaymentDetailDialogComponent>;
    private scrollParams = new ScrollParams();
    private scrollSubscriber = null;
    private loading: boolean = true;
    private payments = [];
    private title = '';
    public onlineOffline: boolean = navigator.onLine;

    constructor(public dialog: MdDialog, private paymentsService: PaymentsService, private route: ActivatedRoute, private cdRef: ChangeDetectorRef,
    private scrollService: ScrollService, private router: Router) {
        window.addEventListener('online', () => {this.onlineOffline = true;});
        window.addEventListener('offline', () => {this.onlineOffline = false;});
    }

    ngOnInit() {
        if (this.route.snapshot.data['title']) {
            this.title = this.route.snapshot.data['title'];
        }
        this.getPaymentHistory();
        this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.getPaymentHistory());
    }


    getPaymentHistory() {
        if (this.scrollParams.recordsFinished) {
            return;
        }
        this.loading = true;
        if(this.onlineOffline){
        this.paymentsService.getPaymentHistory(this.scrollParams.page).subscribe((res) => {
            if (res.length > 0) {
                this.scrollParams.page++;
                Array.prototype.push.apply(this.payments, res);
            } else {
                this.scrollParams.recordsFinished = true;
            }
            this.loading = false;
            this.payments = _.uniqBy(this.payments, 'id');
        });
        } else {
            this.loading = false;
        }
    }

    openPaymentDetail(history: any) {
        this.dialogRef = this.dialog.open(PaymentDetailDialogComponent, {
            disableClose: false,
            width: '520px'
        });
        this.dialogRef.componentInstance.history = history;
    }

    resetScrollParams() {
        this.scrollParams = new ScrollParams();
    }

    ngOnDestroy() {
        if (this.scrollSubscriber != null) {
            this.scrollSubscriber.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/user/payment-history/payment-history.component.ts